/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Logo_UrlInputs */

const cs_settings_office_logo_url = /** @type {(inputs: Settings_Office_Logo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL loga`)
};

const en_settings_office_logo_url = /** @type {(inputs: Settings_Office_Logo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo URL`)
};

/**
* | output |
* | --- |
* | "Logo URL" |
*
* @param {Settings_Office_Logo_UrlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_logo_url = /** @type {((inputs?: Settings_Office_Logo_UrlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Logo_UrlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_logo_url(inputs)
	return cs_settings_office_logo_url(inputs)
});